import { useEffect, useState } from 'react';
import { FinancingApi } from '@servicetitan/financing-api-client';
import { useDependencies } from '@servicetitan/react-ioc';
import { useMutation } from '@tanstack/react-query';
import { DecisionDataStore } from '../decision';
import { SignatureDataStore } from '../loan-agreement';
import { LoanSignStatus } from './LoanSignStatus';
import { LoadingScreen } from '@servicetitan/financing-utils-shared';

export const Container = () => {
    const [apiClient] = useDependencies(FinancingApi);
    const { decisionData } = DecisionDataStore.useStore();
    const { signatureData, setSignatureData } = SignatureDataStore.useStore();
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [isSigningLoan, setIsSigningLoan] = useState(false);

    const { applicantSignature, coApplicantSignature } = signatureData;
    const loanId = decisionData?.loanId ?? '0';

    const mutation = useMutation({
        mutationKey: ['signLoanDocument'],
        mutationFn: () =>
            apiClient.loansSignLoanDocument(loanId, {
                signedDocument: {
                    primaryApplicantSignature: applicantSignature,
                    coApplicantSignature,
                },
            }),
        onSuccess: () => {
            setSuccess(true);
            setSignatureData({ ...signatureData, signedSuccessfully: true });
        },
        onError: () => {
            setError(true);
            setSignatureData({ ...signatureData, signedSuccessfully: false });
        },
    });

    useEffect(() => {
        if (!isSigningLoan) {
            mutation.mutate();
            setIsSigningLoan(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return success || error ? (
        <LoanSignStatus error={error} />
    ) : (
        <LoadingScreen message="Processing your loan agreement..." />
    );
};
